import Vue from 'vue'

class CatchupOnboarding {
  public state = Vue.observable({
    isDisplayed: false,
    isInitialised: false
  })
}

export const catchupOnboarding = new CatchupOnboarding()